import React, { useEffect, useState } from 'react';
import { BannerWrapper, Wrapper } from './styled';
import Layout from '../../components/Layout';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { GetPosts, GetSeriesNum, GetTags } from '../../service/blog';
import {
	SkeletonBanner,
	SkeletonList,
	SkeletonListRight,
	SkeletonMoBanner,
	SkeletonSeriesWrap,
} from '../../components/Skeleton';
import { seriresAtom, seriresNumAtom, shuffleAtom } from '../../atom/taxonomy';
import { useRecoilState, useRecoilValue } from 'recoil';

const SearchTag = () => {
	const params = useParams();

	const query = new URLSearchParams(useLocation().search);
	const searchPaged = query.get('paged');

	const [paged, setPaged] = useState(searchPaged || 1);
	const postsPerPage = 8;
	const [items, setItems] = useState([]);
	const [s, setS] = useState(params?.keyword);
	const nav = useNavigate();
	const [total, setTotal] = useState(0);
	const [maxPaged, setMaxPaged] = useState(1);
	const [seriesNum, setSeriesNum] = useRecoilState(seriresNumAtom);
	const [shuffle, setShuffle] = useRecoilState(shuffleAtom);
	const series = useRecoilValue(seriresAtom);

	function shuffleArray(array) {
		const shuffledArray = [...array]; // Create a copy of the original array
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [
				shuffledArray[j],
				shuffledArray[i],
			];
		}
		return shuffledArray;
	}

	useEffect(() => {
		GetPosts({
			paged: 1,
			postsPerPage: 8,
			tag: params?.keyword,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setItems(res.data.body.items);
					setTotal(res.data.body.total);
					setMaxPaged(res.data.body.maxPaged);
				} else {
					setItems(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [params?.keyword]);

	const [tags, setTags] = useState([]);

	useEffect(() => {
		GetTags({})
			.then((res) => {
				if (res.data.code == 200) {
					setTags(res.data.body.result);
				} else {
					setTags(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [pocket, setPocket] = useState([]);

	useEffect(() => {
		const shuffledObjects = shuffleArray(shuffle);
		setPocket(shuffleArray(seriesNum));
		console.log(77, shuffledObjects);
		setShuffle(shuffledObjects);
		GetSeriesNum({})
			.then((res) => {
				console.log(res);

				const sortedObjects = [...res.data.body.array]; // Create a copy of the array
				sortedObjects.sort((a, b) => b.value - a.value); // Sort by 'count' in ascending order

				console.log(123, sortedObjects);
				setSeriesNum(sortedObjects);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const DoSearch = () => {
		if (s) {
			let d = s.replace('#', '');
			nav(`/tag/${d}`);
		}
	};

	const DoEnter = (e) => {
		if (e.key === 'Enter') {
			DoSearch();
		}
	};

	const onPaging = (page) => {
		console.log(page);
		nav('/tag?paged=' + page);
		window.scrollTo(0, 0);
		setItems(null);
		setPaged(page);
	};

	return (
		<Layout>
			<Wrapper>
				<div className="flex-wrapper">
					<div className="left">
						<div className="input-box">
							<img src="/images/icon-search01.svg" alt="" />
							<input
								onChange={(e) => setS(e.target.value)}
								onKeyDown={DoEnter}
								type="text"
								value={`${s.slice(0, 1) == '#' ? s : '#' + s}`}
							/>
						</div>
						<div>
							{!items ? (
								<>
									<div className="result">
										<div className="result-box">
											<p>
												검색 결과가 없어요
												<br /> 다른 키워드를 검색해보세요!
											</p>
										</div>
									</div>
								</>
							) : items?.length ? (
								<>
									<div className="total-box">
										<p>
											총 <span>{total}</span>개의 검색 결과가 있습니다.
										</p>
									</div>
									<div className="article-wrap">
										<div className="flex-wrap">
											<div className="left-box">
												{items?.map((item, key) => (
													<Link to={`/blog/${item?.ID}`} className="card-box">
														<div className="article-card" key={key}>
															<div>
																<div
																	className="article-img"
																	style={{
																		backgroundImage: `url(${
																			item?.thumbnail || '/images/no-image.png'
																		})`,
																	}}
																></div>
															</div>
															<div className="text-box">
																<div className="tag-box">
																	{item?.tags?.length
																		? item?.tags?.map((i, k) => (
																				<p className="cate">#{i?.name}</p>
																		  ))
																		: null}
																</div>
																<h3>{item?.postTitle}</h3>
																<p className="content">{item?.postContent}</p>
																<div className="flex">
																	<div className="user-box">
																		{item.authors ? (
																			<>
																				{item.authors.map((i, k) => (
																					<a
																						className="user"
																						style={{
																							backgroundImage: `url(${i?.postAuthorImg})`,
																						}}
																					></a>
																				))}
																			</>
																		) : (
																			<div
																				className="user"
																				style={{
																					backgroundImage: `url(${item?.postAuthorImg})`,
																				}}
																			></div>
																		)}
																	</div>
																	{item.authors ? null : (
																		<p>{item.postAuthorName}</p>
																	)}
																	{item.series ? (
																		<p className="name">
																			<img
																				src="/images/icon-lightning.svg"
																				alt=""
																			/>
																			{item?.series}
																		</p>
																	) : null}
																	<p className="date">{item?.postDate}</p>
																</div>
															</div>
														</div>
													</Link>
												))}
											</div>
										</div>
									</div>
								</>
							) : (
								<>
									<div className="total-box">
										<p>
											총 <span>{total}</span>개의 검색 결과가 있습니다.
										</p>
									</div>
									<SkeletonList />
									<SkeletonList />
									<SkeletonList />
									<SkeletonList />
									<SkeletonList />
									<SkeletonList />
									<SkeletonList />
								</>
							)}
						</div>
						<Pagination
							total={total}
							postsPerPage={postsPerPage}
							paged={paged}
							maxPaged={maxPaged}
							onPaging={onPaging}
						/>
					</div>
					<div className="mo-banner-wrap">
						{items?.length ? (
							<div
								className="mo-banner"
								style={{ backgroundImage: `url(/images/mo-banner.png)` }}
							>
								<p className="title">
									새로운 금융IT 세상을 만들어갈 인재를 모십니다.
								</p>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<span>
										채용공고 보러가기
										<img src="/images/icon-banner-more.svg" alt="" />
									</span>
								</a>
							</div>
						) : (
							<SkeletonMoBanner />
						)}
						<div className="line"></div>
					</div>
					{pocket?.length ? (
						<div className="right">
							<div className="series">
								<h3 onClick={() => console.log(pocket)}>추천 포켓</h3>
								<div className="series-list">
									{pocket?.length ? (
										pocket.slice(0, 3).map((item, key) => (
											<Link to={`/blog/series/${series[item?.key]?.ID}`}>
												<div className="list" key={key}>
													<div
														className="seriesimg"
														style={{
															backgroundImage: `url(${shuffle[key]?.moThumbnail})`,
														}}
													></div>
													<div className="text-box">
														<h4>{item?.title}</h4>
														<p>게시글 {item?.value}개</p>
													</div>
												</div>
											</Link>
										))
									) : (
										<></>
									)}
								</div>
							</div>
							<div className="tag">
								<h3>최근 가장 인기있는 태그</h3>
								<ul>
									{tags.map((item, key) => (
										<Link to={`/tag/${item?.value?.name}`}>
											<li key={key}>#{item?.value?.name}</li>
										</Link>
									))}
								</ul>
							</div>
						</div>
					) : (
						<SkeletonSeriesWrap />
					)}
				</div>

				<BannerWrapper>
					{items?.length ? (
						<div
							className="banner"
							style={{ backgroundImage: `url(/images/banner-img02.png)` }}
						>
							<p className="title">
								새로운 금융IT 세상을 만들어갈 인재를 모십니다.
							</p>
							<a href="https://kbds.career.greetinghr.com/" target="_blank">
								<span>
									채용공고 보러가기
									<img src="/images/icon-banner-more.svg" alt="" />
								</span>
							</a>
						</div>
					) : (
						<SkeletonBanner />
					)}
				</BannerWrapper>
			</Wrapper>
		</Layout>
	);
};

export default SearchTag;
